import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const styles = {
  toggle: {
    color: 'rgb(70, 130, 180)',
    marginLeft: 4,
    cursor: 'pointer',
  },
};

export default class Truncate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
    };
  }

  toggleExpand = (e) => {
    e.preventDefault();
    this.setState({ expanded: !this.state.expanded });
  }

  render() {
    const { expanded } = this.state;
    const { length, message } = this.props;
    if (!message) { return <span />; }
    if (message.length < length) { return <span>{message}</span>; }
    return (
      <div>
        <div>
          {message.slice(0, expanded ? undefined : length)}
          {expanded ? '' : '...'}
          {expanded ?
            <div onKeyDown="" tabIndex="0" role="button" style={styles.toggle} href="" onClick={this.toggleExpand} ><FormattedMessage id="Truncate.Less" /></div> :
            <div onKeyDown="" tabIndex="0" role="button" style={styles.toggle} href="" onClick={this.toggleExpand} ><FormattedMessage id="Truncate.More" /></div>
          }
        </div>

      </div>
    );
  }
}

Truncate.defaultProps = {
  length: 300,
  message: '',
};

Truncate.propTypes = {
  length: PropTypes.number,
  message: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/Truncate.js